var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWhatsapp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 45,
    viewBox: "0 0 44 45",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_188_53)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M31.7233 29.3814C32.1187 28.266 32.1187 27.32 32.0057 27.1153C31.8928 26.9106 31.5751 26.7976 31.095 26.5576C30.615 26.3176 28.2853 25.1668 27.8476 25.0115C27.417 24.8492 27.0005 24.9056 26.6757 25.3645C26.2168 26.0069 25.765 26.6564 25.405 27.0518C25.1155 27.3553 24.6496 27.3977 24.2543 27.2353C23.7248 27.0165 22.2493 26.494 20.428 24.8774C19.016 23.6208 18.0559 22.0606 17.7806 21.5876C17.5053 21.1076 17.7524 20.8322 17.9712 20.571C18.2112 20.2745 18.4372 20.0627 18.6842 19.7874C18.9243 19.5121 19.0584 19.3638 19.2137 19.0391C19.3761 18.7214 19.2631 18.3967 19.1431 18.1566C19.0302 17.9166 18.0701 15.5799 17.6747 14.6268C17.357 13.8715 17.1241 13.8362 16.644 13.822C16.4816 13.815 16.2981 13.8009 16.1004 13.8009C15.4792 13.8009 14.8226 13.9844 14.4344 14.3868C13.9543 14.8739 12.7683 16.0176 12.7683 18.3543C12.7683 20.691 14.4767 22.9572 14.7026 23.2749C14.9426 23.5925 18.0277 28.4637 22.8212 30.4474C26.5769 32.0005 27.6852 31.8593 28.5394 31.6758C29.789 31.4075 31.3492 30.4827 31.7374 29.3744L31.7233 29.3814ZM22.2352 6.33887C31.9069 6.33887 39.6371 14.8033 38.4158 24.708C37.491 32.2264 31.3209 38.1989 23.7813 38.8907C19.8773 39.2507 16.2416 38.2342 13.2625 36.2645L6.99353 38.2695L9.0267 32.2123C7.07119 29.5297 5.92047 26.2187 5.92047 22.6466C5.92047 18.1496 7.74891 14.0691 10.6998 11.1182C13.6507 8.16731 17.7312 6.33887 22.2211 6.33887H22.2282H22.2352Z",
    fill: "#2B5D75"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.0788 2.30054H11.3846C6.13279 2.30054 1.87534 6.55799 1.87534 11.8098V33.504C1.87534 38.7558 6.13279 43.0133 11.3846 43.0133H33.0788C38.3306 43.0133 42.5881 38.7558 42.5881 33.504V11.8098C42.5881 6.55799 38.3306 2.30054 33.0788 2.30054Z",
    stroke: "#2B5D75",
    strokeWidth: 3.55401,
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_188_53"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 43.5366,
    height: 43.5366,
    fill: "white",
    transform: "translate(0.463379 0.888672)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhatsapp);
export default __webpack_public_path__ + "static/media/whatsapp.000dfb8d772ad04513f57ae24ace184d.svg";
export { ForwardRef as ReactComponent };